<template>
  <div class="mainSection">
    <div class="container">
      <LanguagesChange />
    </div>
  </div>
</template>

<script>
import LanguagesChange from 'components/setting/languages/LanguagesChange'
export default {
  name: 'settingLanguages',
  components: { LanguagesChange },
}
</script>

<style lang="scss" scoped></style>
